import React from "react";
import { motion } from "framer-motion";
import { ClipboardList, Gauge, ShieldCheck } from "lucide-react";
import { fadeUp } from "./anim";

const HOW = [
  { icon: ClipboardList, step: "01", title: "Assess a booking", desc: "Enter the booking details \u2014 stay length, group size, lead time and property. Guest initials only, never names." },
  { icon: Gauge, step: "02", title: "Review the risk analysis", desc: "Get a deterministic 0\u2013100 risk score with themed sub-scores and a cautious AI summary of the warning signals." },
  { icon: ShieldCheck, step: "03", title: "Book with confidence", desc: "Accept bookings knowing you\u2019ve added a professional, compliant layer of protection \u2014 with an evidence report if you need it." },
];

export const HowItWorks = () => (
  <section id="how" className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
    <motion.div {...fadeUp} className="mx-auto max-w-2xl text-center">
      <h2 className="font-display text-3xl font-semibold tracking-tight" data-testid="how-it-works-heading">How it works</h2>
      <p className="mt-3 text-muted-foreground">Three simple steps from booking details to a confident decision.</p>
    </motion.div>
    <div className="mt-10 grid gap-5 md:grid-cols-3">
      {HOW.map((s, i) => (
        <motion.div key={s.title} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.08 }}
          className="group rounded-xl border bg-card p-6 shadow-[0_1px_2px_rgba(15,23,42,0.06)] transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-[0_14px_34px_rgba(15,23,42,0.10)]"
          data-testid={`how-step-${i + 1}`}>
          <div className="flex items-center justify-between">
            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary text-primary-foreground transition-transform duration-200 group-hover:scale-105">
              <s.icon className="h-5 w-5" />
            </div>
            <span className="font-display text-sm font-semibold text-muted-foreground/50">{s.step}</span>
          </div>
          <h3 className="mt-4 font-display text-lg font-semibold">{s.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
